import subMenuBuild from '@/utils/subitems.links.build';

export default function (locale: string, $t: (a: any) => any) {
  return [ ];
}
